import cn from 'classnames';
import { Form, withFormik } from 'formik';
import * as Yup from 'yup';

import TextField from 'components/common/forms/TextField';
import Search from 'components/icons/actions/Search';
import useBrand from 'hooks/useBrand';
import { TEMPO } from 'lib/constants';

const MenuSearch = ({
  fieldClass,
  handleSearch,
  trailingContentClass,
  values,
  handleSearchFocus,
}) => {
  const isTempo = useBrand(TEMPO);

  return (
    <Form>
      <TextField
        containerClass="w-full"
        name="searchTerm"
        label="Search for recipes"
        labelClass="sr-only"
        buttonStackedMobile
        placeholder={isTempo ? 'Search all of our recipes' : 'Popular: Oven Ready, Chicken'}
        autoComplete={isTempo ? 'on' : 'off'}
        onFocus={isTempo ? () => {} : handleSearchFocus}
        value={values.searchTerm}
        fieldClass={cn(fieldClass)}
        transitionGroupComponent={null}
        trailingContent={
          <button className={cn('btnPrimary -ml-10 h-8 w-8 rounded-full align-middle')}>
            <Search className="h-6 w-6 align-bottom" />
            <span className="sr-only">Search</span>
          </button>
        }
        trailingContentClass={trailingContentClass}
        submitFormMethod={() => {
          if (values.searchTerm.replace(/\s/g, '') !== '') {
            handleSearch({ params: { searchTerm: values.searchTerm } });
          }
        }}
      />
    </Form>
  );
};

const ValidationSchema = Yup.object().shape({
  searchTerm: Yup.string()
    .trim()
    .required()
    .test('searchTerm', 'Must enter a valid input ', value => value?.replace(/\s/g, '') !== ''),
});

MenuSearch.propTypes = {
  fieldClass: PropTypes.string,
  handleSearch: PropTypes.func,
  searchTerm: PropTypes.string,
  trailingContentClass: PropTypes.string,
  values: PropTypes.shape({
    searchTerm: PropTypes.string,
  }),
  handleSearchFocus: PropTypes.func,
};

export default withFormik({
  validationSchema: ValidationSchema,
  enableReinitialize: true,
  mapPropsToValues: props => {
    return {
      searchTerm: props.searchTerm || '',
    };
  },
  handleSubmit: (values, { props }) => props.handleSearch({ params: values }),
  displayName: 'Search',
})(MenuSearch);
